module.exports = __webpack_public_path__ + "static/media/splash1.c386b899.png";